namespace GeniuzPOS.CustomReport {
    export interface ReportCusAgingForm {
    }

    export class ReportCusAgingForm extends Serenity.PrefixedContext {
        static formKey = 'CustomReport.ReportCusAging';
    }
}
